import type { Ctx } from "@milkdown/kit/ctx";
import { editorViewOptionsCtx } from "@milkdown/kit/core";

import "./style.css";

/**
 * Preparo theme for Milkdown
 *
 * A custom theme based on Nord colors that integrates:
 * - Base Milkdown/ProseMirror styles
 * - Nord color palette
 * - Pandoc Essentials preset styles (spans, divs, superscript)
 * - Preparo-specific customizations
 */
export function preparo(ctx: Ctx): void {
  ctx.update(editorViewOptionsCtx, (prev) => {
    const prevClass = prev.attributes;

    return {
      ...prev,
      attributes: (state) => {
        const attrs =
          typeof prevClass === "function" ? prevClass(state) : prevClass;

        const existingClass = attrs?.class || "";

        return {
          ...attrs,
          class: `milkdown milkdown-theme-preparo ${existingClass}`.trim(),
        };
      },
    };
  });
}

export default preparo;
